import { ReactNode, useEffect, useState } from 'react';
import FocusTrap from 'focus-trap-react';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';

import FontIcon from 'components/icons';

type MenuDropDownProps = {
  className?: string,
  title: string,
  openMenu: string,
  setOpenMenu: (value: string) => void,
  children: ReactNode,
};

export const MenuDropDown = ({ className, title, openMenu, setOpenMenu, children }: MenuDropDownProps) => {
  const [activateMenu, setActivateMenu] = useState(false);
  const [clickMenu, setClickMenu] = useState(false);
  const breakpoints = useBreakpoint();

  useEffect(() => {
    if (openMenu && openMenu !== title) {
      setActivateMenu(false);
    }
  }, [openMenu]);

  const mouseEnter = () => {
    if (!breakpoints.smNav) {
      setActivateMenu(true);
      setOpenMenu(title);
    }
  }

  const mouseLeave = () => {
    if (!breakpoints.smNav) {
      setActivateMenu(false);
      setOpenMenu('');
    }
  }

  function menuItemClicked() {
    setActivateMenu(cur => !cur);
    setClickMenu(cur => !cur);
    setOpenMenu(title);
  }

  function deactivate() {
    setActivateMenu(false);
    setClickMenu(false);
    setOpenMenu('');
  };

  return (
    <FocusTrap 
      active={ activateMenu && clickMenu }
      focusTrapOptions={ {
        onDeactivate: () => deactivate(),
        allowOutsideClick: true,
        clickOutsideDeactivates: true,
    } }>
      <li className={`menu-list-item is-dropdown ${className}`}
        onMouseEnter={ mouseEnter }
        onMouseLeave={ mouseLeave }
      >
        <button
          type="button"
          className="menu-item"
          onClick={ menuItemClicked }
          aria-expanded={ activateMenu }
          aria-haspopup="true"
        >
          {title}
          <FontIcon icon="chevron-up" className="is-hidden-mobile-nav" />
          <FontIcon icon="arrow-right" className="is-hidden-tablet-nav" />
        </button>

        <div
          className="sub-menu-container"
          aria-hidden={ !activateMenu }
        >
          <div className="sub-menu">
            <div className="mobile-back is-hidden-tablet-nav">
              <button type="button" onClick={ () => setActivateMenu(false) }><FontIcon icon="arrow-left" />Back</button>
            </div>
            { children }
          </div>
        </div>
      </li>
    </FocusTrap>
  );
};